export default __webpack_public_path__ + "static/media/image.aura-systems-pvt-ltd.bb12c6fc.png";